const NOT_APPLY = 0;
const VALID = 1;
const EXPIRED = 3;

export default {
  NOT_APPLY,
  VALID,
  EXPIRED
};
